export const environment = {
  production: false,
  baseUrl: 'https://repository-documentale-mia-staging.enac.googlecloud.it/api'
};
